import { ProjectVariable } from "../../../../Admin/ProfessionalServices/common/types/ProjectVariable";

const selectOptionsOf = (variable: ProjectVariable) =>
  variable.select_options?.length
    ? variable.select_options
    : variable["select-options"] || [];

/**
 * Required service variables the API cannot fill on its own when it saves a
 * project service as a standard: it falls back to a variable's default select
 * option, so only the ones without a default need asking for.
 */
export const variablesToPrompt = (
  variables: ProjectVariable[]
): ProjectVariable[] =>
  variables.filter(
    (variable) =>
      variable.required &&
      !selectOptionsOf(variable).some((option) => option.default)
  );

/** Prompted values keyed by variable name, blanks dropped. */
export const promptedValues = (
  variables: ProjectVariable[],
  values: Record<string, string>
): Record<string, string> =>
  variables.reduce<Record<string, string>>((acc, variable) => {
    const value = String(values[variable.name] ?? variable.value ?? "").trim();
    if (value) acc[variable.name] = value;
    return acc;
  }, {});

export const allPrompted = (
  variables: ProjectVariable[],
  values: Record<string, string>
): boolean =>
  Object.keys(promptedValues(variables, values)).length === variables.length;
